import * as $ from 'jquery';

import { WidgetBase } from '../../../_common/platform/ts/WidgetBase';
import { classToolBar as mainModule } from './main';
import * as Config from './config';
import { init as mainTheme } from '../../../pdc-widget-toolbar/src/ts/themes/main';

declare var require: any;
require('../sass-main/pdc-widget-toolbar.sass');

export class classToolBar extends WidgetBase {
    public static _name: string = Config.name;
    public static moduleName: string = Config.moduleName;
    public static icon: string = Config.icon;
    public static group: string = Config.group;
    public static namespace: string = Config.namespace;

    public static themeModule = mainTheme;

    public static load() {
        var def = $.Deferred();

        require.ensure(
            ['./main'],
            (require) => {
                var module: typeof mainModule = require('./main');

                def.resolve(module);
            },
            'pdc-widget-toolbar'
        );

        return def;
    }

    constructor(
        values: { [fieldName: string]: any },
        locked: { [fieldName: string]: any },
        ignoreValidation?: boolean,
        glob: any = {}
    ) {
        super(values, locked, ignoreValidation, glob);
    }
}

WidgetBase.register(classToolBar);
